export default __webpack_public_path__ + "static/media/hermit2.36c055ab.jpeg";